import React, { ReactNode } from 'react'

interface IInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType<{}>
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
}

const FileInput: React.FC<IInput> = (
    {
        changeHandler,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        blurHandler,
        require = true,
        id,
    }
) => {

    // @ts-ignore
    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <input
                id={id}
                className={`block w-full text-xs bg-white p-[2px] rounded-md border border-slate-200 cursor-pointer ${customClassName ? customClassName : ""} ${validationError ? "border border-red-500" : ""}`}
                type="file"
                accept=".xml"
                name={name}
                onChange={changeHandler}
                onBlur={blurHandler}
                disabled={disabled}
                required={require}
            />
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default FileInput